/**
 * Cliente del Procedimiento constructivo (documento imprimible por concepto de
 * APU-IA sintético).
 *
 * `getProcedimiento` trae el estado + el HTML de UNA variante. Si no está en
 * caché (o el APU cambió), el backend lo encola y responde `status:'running'`; la
 * UI hace polling hasta `completed`. El `html` puede venir aunque `stale=true`.
 */
import { apiFetch } from './client.js';
import type { ProcedimientoConstructivo, ProcedimientoVariante } from '@supernova/shared';

export type { ProcedimientoConstructivo, ProcedimientoVariante } from '@supernova/shared';
export { PROCEDIMIENTO_VARIANTE_DEFAULT } from '@supernova/shared';

export async function getProcedimiento(
  conceptId: string,
  variante: ProcedimientoVariante,
): Promise<ProcedimientoConstructivo> {
  return await apiFetch<ProcedimientoConstructivo>(
    `/api/v1/apu-ia/concepts/${conceptId}/procedimiento?variante=${variante}`,
  );
}
